import { Component, Input, OnInit } from '@angular/core';
import { Currency, Lesson, ExExercise } from '@df/interfaces';
import { declensionOfNumerals } from '@app/_utils/helpers';

@Component({
    selector: 'app-stat-lesson-desc',
    templateUrl: './stat-lesson-desc.component.html',
    styleUrls: ['./stat-lesson-desc.component.scss']
})
export class StatLessonDescComponent implements OnInit {
    @Input() lesson: Lesson;
    @Input() avg_resolve_speed: number;
    @Input() avg_amount_speed: number;
    @Input() show_second_row: boolean = true;
    @Input() currency: Currency;
    @Input() extra_exercise: ExExercise;

    constructor() {}

    ngOnInit() {}

    declensionOfNumerals(amount: number): string {
        return declensionOfNumerals(amount, this.currency);
    }

    getFormData(correct, incorrect): string {
        if (incorrect === 0) {
            return correct;
        } else {
            return correct + '/' + incorrect;
        }
    }
}
